import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferProgramBlockDto, OfferProgramDto } from '../Types/offerProgramTypes';
import { offerProgramApi } from './offerProgramApi';

export const extendedOfferProgramApi = offerProgramApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllForOffer: builder.query<OfferProgramDto[], number>({
      async queryFn(offerId, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `/offer-program/offer/${offerId}`,
          method: 'GET',
        });

        const status = (result as any)?.error?.status;
        if (status === 404) {
          return { data: [] };
        }

        if ((result as any)?.error) {
          return { error: (result as any).error };
        }

        return { data: (result as any).data as OfferProgramDto[] };
      },
      providesTags: (result, error, offerId) => {
        if (result) {
          return [
            { type: TagTypes.OfferProgram, id: offerId },
            ...result.map(({ id }) => ({ type: TagTypes.OfferProgram, id })),
          ];
        }
        return [{ type: TagTypes.OfferProgram, id: offerId }];
      },
    }),
    assignProgramTemplate: builder.mutation<void, { offerId: number; templateId: number }>({
      query: ({ offerId, templateId }) => ({
        url: `/offer-program/offer/${offerId}/assign-program-template`,
        method: 'POST',
        body: { offerId, templateId },
      }),
      invalidatesTags: (result, error, { offerId }) => [
        { type: TagTypes.OfferProgram, id: offerId },
      ],
    }),
    generateOfferProgram: builder.mutation<
      OfferProgramDto[],
      { blocks: OfferProgramBlockDto[]; totalDays: number; offerId: number }
    >({
      query: (body) => ({
        url: `/offer-program/generate`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { offerId }) => [
        { type: TagTypes.OfferProgram, id: offerId },
      ],
    }),
  }),
});

export const {
  useGetAllForOfferQuery: useGetOfferProgramsForOfferQuery,
  useGenerateOfferProgramMutation,
  useAssignProgramTemplateMutation,
} = extendedOfferProgramApi;
